import { render, staticRenderFns } from "./ResetPasswordToken.vue?vue&type=template&id=666e22a6&"
import script from "./ResetPasswordToken.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports